/**
 * Manual 3.2 Initial Lodging Round.
 *
 * Frontend AI auto-pick: always pick own faction. Mirrors the backend
 * Fossa default and keeps simulations from getting stuck in GAME_SETUP.
 *
 * 2026-05-14: Initial Lodging Round goes seat-by-seat (see
 * engine/round_choices/initial_lodging_round.py). All six seats
 * start in GAME_SETUP, but only the one marked as game.current_player
 * is allowed to send an InitialLodging response — every other seat's
 * click comes back as "Initial Lodging response from non-active seat
 * N." The frontend AI used to fire all Feai seats in parallel on
 * launch; gate the execute on current_player so we wait our turn.
 */
export default function artificialInitialLodging(gamePlayerController, aiPackage) {
    const gamePlayer = gamePlayerController.gamePlayerData;
    // Read from game.gameData directly; controller.gameData is only
    // synced inside gamePlayerEventListener, which runs *after* the
    // game-event listener that fires this AI on a current_player
    // advance — so the controller's copy is one tick stale here.
    const gameData = gamePlayerController.game && gamePlayerController.game.gameData;
    const factionId = gamePlayer.faction;
    const isActiveSeat = gameData && gameData.current_player === gamePlayer.id;
    aiPackage.success = true;
    aiPackage.addToMessage(`Initial Lodging - own faction ${factionId}`);
    aiPackage.addProvenance(
        'Which faction matches my Hotel?',
        `Faction ${factionId}`,
        'Mirror of backend default: pick own faction.');
    if (!isActiveSeat) {
        aiPackage.addToMessage(
            'Waiting for my turn in the Initial Lodging Round.');
        return;
    }
    if (aiPackage.execute) {
        gamePlayerController.gamePlayerApi.initialLodgingChoice(factionId);
    }
}
